import Settings from "./Settings"
import Notification from "./Notification"
import Menu from "./Menu"

// eslint-disable-next-line
export default {
    Settings,
    Notification,
    Menu
}
